module.exports = __webpack_public_path__ + "static/media/Susan Tang.334f57c8.png";